<template>
  <div
    class="flex flex-col sm:flex-wrap md:flex-row gap-3 bg-opacity-90"
    :class="{
      'bg-untitled-gray-50': !isKintz,
    }"
  >
    <div
      class="p-2 sm:p-3 rounded-md shadow flex-1 flex justify-center items-center cursor-pointer"
      @click="handleClickTab('enrolled')"
      :class="[
        {
          'bg-untitled-gray-200 text-untitled-gray-600':
            selectedMainTab === 'enrolled' && !isKintz,
          'bg-white text-untitled-gray-600':
            selectedMainTab !== 'enrolled' && !isKintz,
          'hover:bg-untitled-gray-100': !isKintz,
          'bg-kintz-primary-1 text-kintz-primary-2':
            selectedMainTab === 'enrolled' && isKintz,
          'bg-kintz-primary-3 text-kintz-primary-4':
            selectedMainTab !== 'enrolled' && isKintz,
          'hover:bg-kintz-primary-1 hover:text-kintz-primary-2': isKintz,
        },
      ]"
    >
      <p class="text-xs font-semibold uppercase text-center">
        {{ tabName }}
      </p>
    </div>
    <div
      class="p-2 sm:p-3 rounded-md shadow flex-1 flex justify-center items-center cursor-pointer"
      @click="handleClickTab('playlist')"
      :class="[
        {
          'bg-untitled-gray-200 text-untitled-gray-600':
            selectedMainTab === 'playlist' && !isKintz,
          'bg-white text-untitled-gray-600':
            selectedMainTab !== 'playlist' && !isKintz,
          'hover:bg-untitled-gray-100': !isKintz,
          'bg-kintz-primary-1 text-kintz-primary-2':
            selectedMainTab === 'playlist' && isKintz,
          'bg-kintz-primary-3 text-kintz-primary-4':
            selectedMainTab !== 'playlist' && isKintz,
          'hover:bg-kintz-primary-1 hover:text-kintz-primary-2': isKintz,
        },
      ]"
    >
      <p class="text-xs font-semibold uppercase text-center">
        {{ userName }} Learning Path & Playlists
      </p>
    </div>
  </div>
</template>

<script setup>
import { useAuthStore } from "@/stores";
import { useHomeCoursesStore } from "@/stores/home/useHomeCourses.store";
import { useHomeTabsStore } from "@/stores/home/useHomeTabs.store";
import { storeToRefs } from "pinia";
import { computed, defineProps, onBeforeMount } from "vue";

const props = defineProps({
  isKintz: {
    type: Boolean,
    default: true,
  },
});

const authStore = useAuthStore();
const homeCoursesStore = useHomeCoursesStore();
const homeTabStore = useHomeTabsStore();

const { selectedMainTab } = storeToRefs(homeTabStore);

const tabName = computed(() => homeCoursesStore.homeTab);
const userName = computed(() => authStore.fullName);
const isKintz = computed(() => props.isKintz);

const handleClickTab = (tabName) => {
  selectedMainTab.value = tabName;
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

onBeforeMount(() => {
  if (selectedMainTab.value === "content") {
    selectedMainTab.value = "enrolled";
  }
});
</script>

<style lang="scss" scoped></style>
